import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M2 13h6v8H2v-8zM9 3h6v18H9V3zM4 15v4h2v-4H4zm7-10v14h2V5h-2z"/>
    <path fill="#34CEFF" fillRule="evenodd" d="M16 8h6v13h-6V8zm2 11v-9h2v9h-2z" clipRule="evenodd"/>
  </SvgIcon>
);